<template>
  <!-- Reviews -->
  <div class="review-sec listing-review">
    <div class="review-header">
      <h4>Reviews</h4>
    </div>
    <div class="rating-wrapper">
      <div class="rating-wraps">
        <h2>4.5<span>/5</span></h2>
        <p>Excellent</p>
        <h6>Based on 256 Reviews</h6>
      </div>
      <div class="rating-progress">
        <div class="progress-info">
          <h6>Service</h6>
          <div class="progress" role="progressbar">
            <div class="progress-bar bg-primary" style="width: 70%"></div>
          </div>
          <div class="progress-percent">4.6</div>
        </div>
        <div class="progress-info">
          <h6>Location</h6>
          <div class="progress" role="progressbar">
            <div class="progress-bar bg-primary" style="width: 85%"></div>
          </div>
          <div class="progress-percent">4.8</div>
        </div>
        <div class="progress-info">
          <h6>Value for Money</h6>
          <div class="progress" role="progressbar">
            <div class="progress-bar bg-primary" style="width: 60%"></div>
          </div>
          <div class="progress-percent">3.0</div>
        </div>
        <div class="progress-info">
          <h6>Facilities</h6>
          <div class="progress" role="progressbar">
            <div class="progress-bar bg-primary" style="width: 65%"></div>
          </div>
          <div class="progress-percent">4.5</div>
        </div>
        <div class="progress-info">
          <h6>Cleanliness</h6>
          <div class="progress" role="progressbar">
            <div class="progress-bar bg-primary" style="width: 90%"></div>
          </div>
          <div class="progress-percent">4.8</div>
        </div>
      </div>
    </div>
    <div class="review-card">
      <div class="review-head">
        <h6>Showing 3 guest reviews</h6>
      </div>
      <ul>
        <li>
          <div class="review-wraps">
            <div class="review-header-group">
              <div class="review-widget-header">
                <span class="review-widget-img">
                  <img
                    src="@/assets/img/profiles/avatar-01.jpg"
                    class="img-fluid"
                    alt="User"
                  />
                </span>
                <div class="review-design">
                  <h6>Johnson</h6>
                  <p>02 Jan 2023</p>
                </div>
              </div>
              <div class="reviewbox-list-rating">
                <p>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <span> (5.0)</span>
                </p>
              </div>
            </div>
            <p>
              It was popularised in the 1960s with the release of Letraset sheets
              containing Lorem Ipsum passages, and more recently with desktop publishing
              software like Aldus PageMaker including versions of Lorem Ipsum.It was
              popularised in the 1960s
            </p>
            <div class="review-reply">
              <a class="btn" href="javascript:;">
                <i class="fa-solid fa-reply"></i>Reply
              </a>
              <div class="review-action">
                <a href="javascript:;"><i class="fa-regular fa-thumbs-up"></i>10</a>
                <a href="javascript:;"><i class="fa-regular fa-thumbs-down"></i>12</a>
                <a href="javascript:;"><i class="fa-regular fa-heart"></i>15</a>
              </div>
            </div>
          </div>
          <ul>
            <li>
              <div class="review-wraps">
                <div class="review-header-group">
                  <div class="review-widget-header">
                    <span class="review-widget-img">
                      <img
                        src="@/assets/img/profiles/avatar-01.jpg"
                        class="img-fluid"
                        alt="User"
                      />
                    </span>
                    <div class="review-design">
                      <h6>Johnson</h6>
                      <p>02 Jan 2023</p>
                    </div>
                  </div>
                  <div class="reviewbox-list-rating">
                    <p>
                      <i class="fas fa-star filled"></i>
                      <i class="fas fa-star filled"></i>
                      <i class="fas fa-star filled"></i>
                      <i class="fas fa-star filled"></i>
                      <i class="fas fa-star filled"></i>
                      <span> (5.0)</span>
                    </p>
                  </div>
                </div>
                <p>
                  It was popularised in the 1960s with the release of Letraset sheets
                  containing Lorem Ipsum passages, and more recently with desktop
                  publishing software like Aldus PageMaker including versions of Lorem
                  Ipsum.It was popularised in the 1960s
                </p>
                <div class="review-reply">
                  <a class="btn" href="javascript:;">
                    <i class="fa-solid fa-reply"></i>Reply
                  </a>
                  <div class="review-action">
                    <a href="javascript:;"><i class="fa-regular fa-thumbs-up"></i>10</a>
                    <a href="javascript:;"><i class="fa-regular fa-thumbs-down"></i>12</a>
                    <a href="javascript:;"><i class="fa-regular fa-heart"></i>15</a>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </li>
        <li>
          <div class="review-wraps wrap-card">
            <div class="review-header-group">
              <div class="review-widget-header">
                <span class="review-widget-img">
                  <img
                    src="@/assets/img/profiles/avatar-02.jpg"
                    class="img-fluid"
                    alt="User"
                  />
                </span>
                <div class="review-design">
                  <h6>Casandra</h6>
                  <p>Reviewed 25 March 2024</p>
                </div>
              </div>
              <div class="reviewbox-list-rating">
                <p>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <span> (5.0)</span>
                </p>
              </div>
            </div>
            <p>
              It was popularised in the 1960s with the release of Letraset sheets
              containing Lorem Ipsum passages, and more recently with desktop publishing
              software like Aldus PageMaker including versions of Lorem Ipsum.It was
              popularised in the 1960s with the elease of Letraset sheets containing Lorem
              Ipsum passages, and more recently with desktop publishing software like
              Aldus Page Maker including versions of Lorem Ipsum.
            </p>
            <div class="review-reply">
              <a class="btn" href="javascript:;"> <i class="fa-solid fa-reply"></i>Reply </a>
              <div class="review-action">
                <a href="javascript:;"><i class="fa-regular fa-thumbs-up"></i>10</a>
                <a href="javascript:;"><i class="fa-regular fa-thumbs-down"></i>12</a>
                <a href="javascript:;"><i class="fa-regular fa-heart"></i>15</a>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <!-- /Reviews -->

  <!-- Leave a Reply -->
  <div class="review-sec leave-reply-form mb-0">
    <div class="review-header">
      <h4>Leave a Reply</h4>
    </div>
    <div class="review-list-rating">
      <div class="row">
        <div class="col-xl-4 col-md-6">
          <div class="set-rating">
            <p>Service</p>
            <div class="rating-selection">
              <input type="checkbox" id="service1" value="1" />
              <label for="service1"></label>
              <input type="checkbox" id="service2" value="2" />
              <label for="service2"></label>
              <input type="checkbox" id="service3" value="3" />
              <label for="service3"></label>
              <input type="checkbox" id="service4" value="4" />
              <label for="service4"></label>
              <input type="checkbox" id="service5" value="5" />
              <label for="service5"></label>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-md-6">
          <div class="set-rating">
            <p>Location</p>
            <div class="rating-selection">
              <input type="checkbox" id="loc1" value="1" />
              <label for="loc1"></label>
              <input type="checkbox" id="loc2" value="2" />
              <label for="loc2"></label>
              <input type="checkbox" id="loc3" value="3" />
              <label for="loc3"></label>
              <input type="checkbox" id="loc4" value="4" />
              <label for="loc4"></label>
              <input type="checkbox" id="loc5" value="5" />
              <label for="loc5"></label>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-md-6">
          <div class="set-rating">
            <p>Facilities</p>
            <div class="rating-selection">
              <input type="checkbox" id="fac1" value="1" />
              <label for="fac1"></label>
              <input type="checkbox" id="fac2" value="2" />
              <label for="fac2"></label>
              <input type="checkbox" id="fac3" value="3" />
              <label for="fac3"></label>
              <input type="checkbox" id="fac4" value="4" />
              <label for="fac4"></label>
              <input type="checkbox" id="fac5" value="5" />
              <label for="fac5"></label>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-md-6">
          <div class="set-rating">
            <p>Value for Money</p>
            <div class="rating-selection">
              <input type="checkbox" id="val1" value="1" />
              <label for="val1"></label>
              <input type="checkbox" id="val2" value="2" />
              <label for="val2"></label>
              <input type="checkbox" id="val3" value="3" />
              <label for="val3"></label>
              <input type="checkbox" id="val4" value="4" />
              <label for="val4"></label>
              <input type="checkbox" id="val5" value="5" />
              <label for="val5"></label>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-md-6">
          <div class="set-rating">
            <p>Cleanliness</p>
            <div class="rating-selection">
              <input type="checkbox" id="clean1" value="1" />
              <label for="clean1"></label>
              <input type="checkbox" id="clean2" value="2" />
              <label for="clean2"></label>
              <input type="checkbox" id="clean3" value="3" />
              <label for="clean3"></label>
              <input type="checkbox" id="clean4" value="4" />
              <label for="clean4"></label>
              <input type="checkbox" id="clean5" value="5" />
              <label for="clean5"></label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="review-list">
        <ul>
          <li class="review-box feedbackbox mb-0">
            <div class="review-details">
              <form class="#">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="input-block">
                      <label>Full Name <span class="text-danger">*</span></label>
                      <input type="text" class="form-control" />
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="input-block">
                      <label>Email Address <span class="text-danger">*</span></label>
                      <input type="email" class="form-control" />
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="input-block">
                      <label>Comments </label>
                      <textarea rows="4" class="form-control"></textarea>
                    </div>
                  </div>
                </div>
                <div class="submit-btn text-end">
                  <button class="btn btn-primary submit-review" type="submit">
                    Submit Review
                  </button>
                </div>
              </form>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!-- /Leave a Reply -->
</template>
<script>
import listing_Review from "@/assets/json/listing-review.json";
export default {
  data() {
    return {
      listing_Review: listing_Review,
    };
  },
};
</script>
